"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ttable_en = void 0;
exports.ttable_en = {
    byDefault: 'Default',
    filter: 'Filter',
    resultsOption: 'No results found',
    clearAll: 'Clear all filters',
    hideColumn: 'Hide column',
    hideOpenColumns: 'Hide/ show columns',
    columnVisibility: 'Columns',
    visibleColumns: 'Visible columns',
    commonColumns: 'Common columns',
    pagingInfo: 'Displayed from {from, number} to {to, number} of {count, number}',
    pagingInfoIfNull: 'No records found',
    rowsPerPage: 'Display by:',
    presetName: 'Preset name',
    placeholderPresetName: 'Enter preset name',
    changeExistedPreset: 'Change the existed one',
    savePreset: 'Save preset',
    save: 'Save',
    invalidDateMessage: 'Invalid date format',
    maxDateMessage: 'Date can not be later than today',
    deletionPreset: 'Deleting the preset',
    confirmDeletionPreset: 'Do you really want to delete the preset "{preset}"?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    from: 'From',
    to: 'until',
    presetManagement: 'Preset management',
    preset: 'Preset',
    common: 'Common',
    default: 'Default',
    accessibilityRule: 'Accessibility Rule',
    upload: 'Upload to file',
    all: 'All',
    minOneDefault: 'At least one default preset must be available to everyone',
    notUniqueSharedRule: 'Accessibility rules should not overlap: the user role can be specified in only one default preset',
    expandRecords: 'Expand records',
    collapseEntries: 'Collapse records',
    lastState: 'Last state',
    group: 'Group',
    column: 'Column',
    noColumnFilter: 'To see available columns use the filters above.',
};
